module.exports = __webpack_public_path__ + "img/company46.4537ed16.png";